/* eslint-disable no-useless-escape */
import { validateRut } from '../../../../domain/utils/utilitarios-frontend-coopeuch/rut';

const EMAIL_PATTERN =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const personalDataUiModel = {
  executiveCode: {
    isValid: () => true,
    value: '',
    errors: [],
  },
  executiveAttending: {
    isValid: (el) => el !== '',
    isVisible: true,
    value: '',
    errors: [],
  },
  rut: {
    isValid: (elm) => validateRut(elm),
    containerCard: 'CardPersonValidation',
    isVisible: true,
    value: '',
    errors: [],
  },
  serialNumber: {
    isValid: (elm) => /^[a-zA-Z0-9]{9}$/.test(elm),
    containerCard: 'CardPersonValidation',
    isVisible: true,
    value: '',
    errors: [],
  },
  previredAuthorization: {
    isValid: (elm) => elm === true,
    containerCard: 'CardPersonValidation',
    isVisible: true,
    value: false,
    errors: [],
  },
  firstName: {
    isValid: (elm) => /^[a-zA-Z'ñÑáéíóúÁÉÍÓÚ ]{2,30}$/.test(elm),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: '',
    errors: [],
  },
  lastName: {
    isValid: (elm) => /^[a-zA-Z'ñÑáéíóúÁÉÍÓÚ ]{2,30}$/.test(elm),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: '',
    errors: [],
  },
  maternalLastName: {
    isValid: (elm) => /^[a-zA-Z'ñÑáéíóúÁÉÍÓÚ ]{2,30}$/.test(elm),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: '',
    errors: [],
  },
  profession: {
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: {
      id: '',
      valor: '',
    },
    errors: [],
  },
  position: {
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    containerCard: 'CardPersonalData',
    isVisible: false,
    value: {
      codigo: '',
      descripcion: '',
    },
    errors: [],
  },
  workActivity: {
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    containerCard: 'CardPersonalData',
    isVisible: true,
    value: {
      id: '',
      valor: '',
    },
    errors: [],
  },
  countryNationality: {
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    containerCard: 'CardPersonalData',
    isVisible: false,
    value: {
      codigo: '',
      descripcion: '',
    },
    errors: [],
  },
  phone: {
    isValid: (elm) => /(^[9]{1}[0-9]{8})+$/.test(elm),
    containerCard: 'CardContactData',
    isVisible: true,
    value: '',
    complement: 'confirmationPhone',
    errors: [],
  },
  confirmationPhone: {
    isValid: (elm) => /(^[0-9]{9})+$/.test(elm),
    containerCard: 'CardContactData',
    isVisible: true,
    value: '',
    complement: 'phone',
    errors: [],
  },
  email: {
    isValid: (elm) => EMAIL_PATTERN.test(elm),
    containerCard: 'CardContactData',
    isVisible: true,
    value: '',
    errors: [],
  },
  address: {
    isValid: (elm) => Object.keys(elm).every((v) => elm[v] !== ''),
    containerCard: 'CardContactData',
    isVisible: true,
    value: {
      street: '',
      numeration: '',
      commune: '',
      country: '',
      latitude: 0,
      longitude: 0,
    },
    anotherData: '',
    errors: [],
  },
  preferredOffice: {
    isValid: (elm) => Object.values(elm).every((v) => v !== ''),
    isVisible: true, // no es un  control, pero si una entidad que tiene que ser validada
    value: {
      id: '',
      name: '',
      region: '',
      commune: '',
      address: '',
      officeHours: '',
    },
    errors: [],
  },
  taxDeclaration: {
    isValid: (elm) => Object.values(elm).some((v) => v === true),
    containerCard: '',
    isVisible: true,
    value: {
      chile: false,
      world: false,
      usa: false,
    },
    errors: [],
  },
};

export default personalDataUiModel;
